















































































































import { Component } from 'vue-property-decorator';
import { PaginationModel, VAction, VHeaders } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { FileHelper as _file } from '@/helper/file.helper';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { mask } from 'vue-the-mask';
import {
  adhocPaymentService,
  paymentReportService,
  repairOrderService,
  storeService,
} from '@/shared';
import { typetimeout } from '@/directives/input';
import { IDialogOption } from '@/models/dialog';
import { DepositLogViewModel } from '@/models/filebunker/depositlog';
import { mapGetters } from 'vuex';
import { RoleType } from '@/helper/enum';
import { Utils } from '@/helper/utils';
import { PaymentDetailViewModel } from '@/models/fixedops/repairorder';
import { VantivRefundViewModel } from '@/models/payment/paymentreport';
import { NotificationType } from '@/helper/enum';
@Component({
  props: ['methodName', 'progress'],
  directives: {
    mask,
    typetimeout,
  },
  computed: {
    pages() {
      return this.pagedAdhocPayment.totalPages;
    },
    validate() {
      return (
        this.selectedPaymentType &&
        Number(this.amountToBePaid) <= Number(this.finalAmount) &&
        Number(this.amountToBePaid) > 0 &&
        this.amountToBePaid !== '0.00'
      );
    },
    isValidTransactionAmount() {
      this.dollarDialog.action.disable = !this.validate;
    },
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    ...mapGetters({ currentRoles: 'getRoles' }),
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    CallCustomer: (resolve) => import('@/components/common/call.customer.vue'),
    SendPaymentLink: () => import('@/components/common/send.payment.link.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    Calendar: () => import('@/components/common/app.calendar.vue'),
  },
})
export default class AdHocPage extends Base {
  public resetFilter: boolean = false;
  public pagedAdhocPayment: any[] = [];
  public isSearchLoading: boolean = false;
  public currentRoles: string[];
  public statusLoading: boolean = false;
  public paymentToRefund: PaymentDetailViewModel = {};
  public refundPreset: any[] = [];
  public refund: VantivRefundViewModel = {};

  public identifier: string = 'ADHOC';
  public accountNumber: any = '';
  public hideAccountNumber: boolean = false;

  public params: any = {
    selecteduser: '',
    paymentstatus: '',
    startDate: '',
    endDate: '',
    isLiveStatus: false,
    selectedAccountNumber: '',
  };
  public flags: any = {
    invalidUrl: false,
    showStartDatePicker: false,
    showEndDatePicker: false,
    loading: false,
    showForm: false,
    showAttachmentDetails: false,
    showEmailPopup: false,
  };
  public pagination = new PaginationModel('createdBy');
  public loading: boolean = false;
  public paymentProvider: string = '';

  public actions: any[] = [];
  public modelValue: DepositLogViewModel;
  public refundAction: any;
  public isRefundAllowed: boolean = false;

  public headers: VHeaders[] = [
    {
      text: 'Name',
      value: 'name',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Receipt Number',
      value: 'receiptNumber',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Payment Status',
      align: 'center',
      value: 'paymentStatus',
      sortable: true,
    },
    {
      text: 'Gl Status',
      align: 'center',
      value: 'glStatus',
      sortable: true,
    },
    {
      text: 'Amount',
      align: 'left',
      value: 'amount',
      sortable: false,
    },
    {
      text: 'Description',
      align: 'left',
      value: 'description',
      sortable: false,
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: 'Action',
      sortable: false,
    },
  ];

  public todayDate: any = _dateTime.currentDate(new Date());
  public statusList: any[] = [];
public blockInvalidChars(e: KeyboardEvent) {
  if (['e', 'E', '+', '-'].includes(e.key)) {
    e.preventDefault();
  }
}
  public confirmRefundDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('dialogSettings.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('dialogSettings.btntxtAgree') as string,
      disable: false,
    },
    onAction: (): void => {
      this.runRefund();
    },
  };

  public showRefundPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t(
      'repairOrderPaymentReport.refundDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'repairOrderPaymentReport.refundDialog.btnSubmit'
      ) as string,
      disable: false,
    },
    onAction: (): void => {
      this.confirmRefund();
    },
    onClose: (): void => {
      this.clear();
    },
  };

  public clear() {
    this.refundPreset = [];
    this.accountNumber = '';
    this.params.selectedAccountNumber = '';
    this.getRefundPreset();
    this.getAccountNumber();
  }

  public maxToDate: any = _dateTime.currentDate(
    _dateTime.addDays(new Date(), 45)
  );

  constructor() {
    super();
  }

  public formatDate(date) {
    if (!date) {
      return null;
    }
    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`;
  }

  public created(): void {
    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.params.startDate = this.$route.query.startDate.toString();
      this.params.endDate = this.$route.query.endDate.toString();
    } else {
      this.params.startDate = this.presentDate();
      this.params.endDate = this.presentDate();
    }
  }

  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'adhocPayment');

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
    if (pagination) {
      this.pagination = pagination;
    }

    this.getDefaultPaymentType();
    this.getAdhocPaymentReport();
    const roles = this.currentRoles;
    if (roles.indexOf(RoleType.AllowRefund) > -1) {
      this.isRefundAllowed = true;
    }
    this.getRefundPreset();
  }

  public setDateValues(dates: any) {
    if (dates.length > 1) {
      this.params.startDate = dates[0];
      this.params.endDate = dates[1];
    }
  }

  public addAdhocPayments() {
    this.$router.push({
      name: 'app.adhocPayment.add',
    });
  }

  public setAction() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-eye',
        title: 'View Adhoc Payments',
        color: 'primary',
        action: (model: any) => {
          this.viewAdhocPayments(model);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-download',
        title: 'Download Receipt',
        color: 'primary',
        visible: (model: any) => {
          if (
            this.paymentProvider == 'Square' &&
            model.paymentStatus == 'Success'
          ) {
            return true;
          } else if (model.paymentStatus == 'Pending') {
            return false;
          }
        },
        action: (model: any) => {
          this.downloadReceipt(model);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-undo-alt',
        title: this.$t(
          'depositLogList.gridHeaders.gridAction.refund'
        ) as string,
        align: 'left',
        disable: (model: any) => {
          if (
            (model.paymentStatus === 'Success' ||
              model.paymentStatus === 'Approved') &&
            !model.refundStatus
          ) {
            return false;
          }
          return true;
        },
        action: (model: any, action: any) => {
          this.showRefund(model, action);
          return ``;
        },
      },
    ];
  }

  public showRefund(payment: any, action: any): void {
    this.paymentToRefund.approvedAmount = Number(payment.amount);
    this.refund.transactionAmount = payment.amount;
    this.modelValue = payment;
    this.refundAction = action;
    this.showRefundPopup.model = true;
  }

  public confirmRefund(): void {
    //this.modelValue = model;
    //this.refundAction = action;
    if (this.refund.transactionAmount > this.paymentToRefund.approvedAmount) {
      this.showAlert(false, 'Refund Amount Can not be greater than Paid Amount, Or please Refresh if you have already processed refund');
      return;
    }

    if(this.params.selectedAccountNumber == '' || this.params.selectedAccountNumber == undefined)
    {
        this.showAlert(false, 'Please Select Preset Account to Refund.');
        return;
    }

    var accountDetails = this.refundPreset.filter(
      (x) => x.id == this.params.selectedAccountNumber
    )[0];
    if (
      accountDetails != null &&
      accountDetails != undefined &&
      !accountDetails.isDmsPostAllowed
    ) {
      this.showAlert(
        false,
        'As per selected configuration debit and credit Account/Control details are same , So Transaction is not allowed.'
      );
      return;
    }
    
    this.confirmRefundDialog.model = true;
  }

  public async searchAdhocPaymentByReceipt(): Promise<void> {
    this.pagination.page = 1;
    await this.getAdhocPaymentReport();
  }

  public async getAdhocPaymentReport(): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const response = await paymentReportService.getAdhocPaymentReport(
        this.pagination,
        this.params.startDate,
        this.params.endDate
      );
      this.pagedAdhocPayment = response.results;
      this.pagination.totalItems = response.total;
      this.setAction();
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'addAdhocPayments') {
      this.addAdhocPayments();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: 'Add Adhoc Payments',
      disabled: false,
      visible: true,
      class: 'btn',
      label: 'Add Adhoc Payments',
      click: 'addAdhocPayments',
      icon: 'fas fa-plus-circle',
      requestProgress: true,
    });
    this.$emit('updateToolBar', buttons);
  }

  public updatePaging(paging: any): void {
    this.pagination = paging;
    const queryStringObj = Object.assign({}, paging);
    if (queryStringObj) {
      queryStringObj.startDate = this.params.startDate;
      queryStringObj.endDate = this.params.endDate;
    }
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getAdhocPaymentReport();
  }

  public searchAdhocPaymentReport() {
    this.pagination.page = 1;
    const queryStringObj = Object.assign({}, this.pagination) as any;
    queryStringObj.startDate = this.params.startDate;
    queryStringObj.endDate = this.params.endDate;
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getAdhocPaymentReport();
  }

  public viewAdhocPayments(model: any): void {
    if (model) {
      this.$router.push({
        name: 'app.adhocPayment.edit',
        params: {
          id: model.receiptNumber.toString(),
        },
      });
    }
  }

  public runRefund(): void {
    this.showRefundPopup.model = false;
    this.processRefund(this.modelValue, this.refundAction);
  }

  public async processRefund(model: any, action: any): Promise<void> {
    try {
      this.confirmRefundDialog.action.disable = true;
      action.loading = true;
      if (this.isRefundAllowed) {
        await adhocPaymentService.refundAsync(
          model.id,
          this.params.selectedAccountNumber,
          this.refund.transactionAmount
        );
        this.showAlert(
          true,
          'Please Wait for few minutes, Refund is in progress.'
        );
        model.refundStatus = true;
        this.refundPreset = [];
        this.accountNumber = '';
        this.refund.transactionAmount = '';
        this.params.selectedAccountNumber = '';
        this.getRefundPreset();
        this.getAccountNumber();
      } else {
        this.showAlert(
          false,
          'You are not allowed refund, Please contact Admin'
        );
      }
    } catch (ex) {
      console.log(ex);
      action.loading = false;
    } finally {
      action.loading = false;
      this.confirmRefundDialog.action.disable = false;
      this.confirmRefundDialog.model = false;
    }
  }

  public async downloadReceipt(request): Promise<void> {
    try {
      const response = await paymentReportService.downloadReceipt(
        request.transactionHeaderId,
        request.lastPaymentDetailId,
        request.paymentType
      );

      if (response?.fileDownloadName) {
        window.open(response.fileDownloadName, '_blank');
      } else {
        this.showNotification(NotificationType.Warning, "Receipt is not available for this transaction.");
      }
    } finally {
      // finally block
    }
  }

  public async getDefaultPaymentType(): Promise<void> {
    try {
      const result = await repairOrderService.getDefaultPaymentProvider();
      this.paymentProvider = result.paymentProvider;
    } finally {
      // finally block
    }
  }

  public getAccountNumber() {
    try {
      this.loading = true;
      if (this.params.selectedAccountNumber == '') {
        this.hideAccountNumber = false;
      } else {
        this.hideAccountNumber = true;
      }
      const account = this.refundPreset.filter(
        (item) => item.id == this.params.selectedAccountNumber
      );
      this.accountNumber = account[0].accountNumber;
    } finally {
      this.loading = false;
    }
  }

  public async getRefundPreset(): Promise<void> {
    try {
      const refundPresets = await storeService.getRefundPresst(this.identifier);
      this.refundPreset = refundPresets;
      // this.refundPreset.unshift({
      //   id: '',
      //   name: 'Default',
      // });
    } finally {
    }
  }
}
